import { LayerDefinition } from './types';

export const droughtDefinition: LayerDefinition = {
  id: 'drought',
  name: 'U.S. Drought Monitor & Outlook',
  category: 'extended_climate',
  categoryLabel: 'Extended Climate & Outlooks',
  icon: '🏜️',
  description: 'Authoritative weekly U.S. Drought Monitor classifications (D0 Abnormally Dry to D4 Exceptional Drought) from NDMC/USDA/NOAA, coupled with NOAA Climate Prediction Center (CPC) Monthly and Seasonal drought tendency outlooks.',
  sourceModels: [
    'National Drought Mitigation Center (NDMC / UNL)',
    'NOAA National Integrated Drought Information System (NIDIS)',
    'USDA World Agricultural Outlook Board',
    'NOAA Climate Prediction Center (CPC)'
  ],
  outputModels: ['Vector Classifications & Tendency Polygons GeoJSON'],
  config: {
    cadence: 'Weekly (Every Thursday) & Monthly'
  }
};

export default droughtDefinition;
